import { useCallback, useContext } from "react";

import { AmplitudeEvents } from "../../constants/amplitude";
import { AmplitudeContext } from "../../contexts/AmplitudeContext";

export type AmplitudeEventParams = {
  event: AmplitudeEvents | string;
  payload?: { [key: string]: unknown };
};

export type Primitive = string | number | boolean;
export interface GetExperimentValueProps {
  flagKey: string;
  userId?: string;
  organizationId?: string;
  userProperties?: Record<string, Primitive>;
  organizationProperties?: Record<string, Primitive>;
}
export const useAmplitude = () => {
  const { isAmplitudeLoading, getExperimentValue, logAmplitudeEvent, resetAmplitude, getAmplitudeDeviceId } =
    useContext(AmplitudeContext);

  const logAmplitudeEventCallback = useCallback(
    (event: AmplitudeEventParams["event"], payload?: AmplitudeEventParams["payload"]) => () => {
      logAmplitudeEvent(event, payload);
    },
    [logAmplitudeEvent]
  );

  return {
    logAmplitudeEvent,
    logAmplitudeEventCallback,
    getExperimentValue,
    isAmplitudeLoading,
    resetAmplitude,
    getAmplitudeDeviceId,
  };
};
